import { ScoreIf } from './score-if';

export class PointsScore extends ScoreIf {

  constructor(private points: number, private totalPoints: number, private weight?: number) {
    super();
  }

  getWeight(): number {
    return this.weight || 1;
  }

  getPoints(): number {
    return this.points;
  }

  getTotalPoints(): number {
    return this.totalPoints;
  }

  getPercent(): number {
    return this.points / this.totalPoints;
  }

}
